import { render, staticRenderFns } from "./ProfileRealNameAuth.vue?vue&type=template&id=1bd84aca&"
import script from "./ProfileRealNameAuth.vue?vue&type=script&lang=ts&"
export * from "./ProfileRealNameAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports